module.exports = __webpack_public_path__ + "img/avatar3.54dd4f24.png";